var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GmapMap',{ref:"mapRef",staticStyle:{"width":"100%","height":"500px","overflow":"hidden","border-bottom-left-radius":"10px","border-bottom-right-radius":"10px"},attrs:{"center":{lat: this.lat, lng:this.lng},"zoom":7,"options":{
        fullscreenControl: false,
        gestureHandling: 'greedy',
        clickableIcons: false
    }}})
}
var staticRenderFns = []

export { render, staticRenderFns }